export default __webpack_public_path__ + "static/media/add-customer.afb7ba6c.svg";